namespace GeniuzPOS.ReportMasterData {
    export class Report_1321Columns {
        static columnsKey = 'ReportMasterData.Report_1321';
    }
}
